(() => {
  const routesNode = document.getElementById('ThemeRoutes');
  const routes = routesNode ? JSON.parse(routesNode.textContent) : {};
  let previousRewardThreshold = null;
  const productDataCache = new Map();

  const drawer = (id) => document.getElementById(id);

  function openDrawer(id) {
    const target = drawer(id);
    if (!target) return;
    target.hidden = false;
    document.body.style.overflow = 'hidden';
    target.querySelector('button, input, a')?.focus();
  }

  function closeDrawers() {
    document.querySelectorAll('[data-drawer]').forEach((element) => { element.hidden = true; });
    closeGiftPicker();
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency
      }).format(value);
    } catch (_) {
      return `$${value.toFixed(2)}`;
    }
  }

  function escapeHtml(value) {
    const node = document.createElement('div');
    node.textContent = value || '';
    return node.innerHTML;
  }

  function isGiftItem(item) {
    return String(item.properties?._cj_free_gift || '').toLowerCase() === 'true';
  }

  function rewardState(cart) {
    const paidQuantity = cart.items.reduce((total, item) => total + (isGiftItem(item) ? 0 : item.quantity), 0);
    const giftItems = cart.items.filter(isGiftItem);
    return {
      paidQuantity,
      giftItems,
      giftQuantity: giftItems.reduce((total, item) => total + item.quantity, 0),
      giftUnlocked: paidQuantity >= 4,
      giftMissing: paidQuantity >= 4 && giftItems.length === 0
    };
  }

  function cartLine(item) {
    const title = escapeHtml(item.product_title);
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<span class="cart-line-size">${escapeHtml(item.variant_title)}</span>` : '';
    const oldPrice = item.original_line_price > item.final_line_price
      ? `<s>${formatMoney(item.original_line_price)}</s>` : '';
    const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=220` : '';
    const image = imageUrl ? `<img src="${escapeHtml(imageUrl)}" width="100" height="100" loading="lazy" alt="${title}">` : '';

    if (isGiftItem(item)) {
      return `<article class="cart-gift-line" data-line-key="${escapeHtml(item.key)}">
        ${image}
        <div>
          <span>Free gift selected</span>
          <h3>${title}</h3>
          ${variant}
          <p>${item.original_line_price > 0 ? `<s>${formatMoney(item.original_line_price)}</s>` : ''} <b>FREE</b></p>
          <button type="button" data-change-gift="${escapeHtml(item.key)}">Change gift</button>
        </div>
      </article>`;
    }

    const quantityControl = `<div class="quantity-stepper"><button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button><output>${item.quantity}</output><button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}">+</button></div>`;

    return `<article class="cart-line" data-line-key="${escapeHtml(item.key)}">
      ${image}
      <div class="cart-line-copy">
        <div class="cart-line-title"><h3>${title}</h3><button type="button" aria-label="Remove ${title}" data-cart-remove="${escapeHtml(item.key)}">⌫</button></div>
        ${variant}
        <div class="cart-line-actions">
          ${quantityControl}
          <div class="cart-line-price">${oldPrice}<strong>${formatMoney(item.final_line_price)}</strong></div>
        </div>
      </div>
    </article>`;
  }

  function updateRewards(quantity, giftSelected = false) {
    const copies = [...document.querySelectorAll('[data-reward-copy]')];
    const progressBars = [...document.querySelectorAll('[data-reward-progress]')];
    if (!copies.length || !progressBars.length) return;

    let message;
    if (quantity === 0) {
      message = 'Add 2 items to get 20% extra discount on your order!';
    } else if (quantity === 1) {
      message = 'Add 1 more to get 20% extra discount on your order!';
    } else if (quantity === 2) {
      message = '20% extra discount unlocked! Add 1 more item to get 25% off.';
    } else if (quantity === 3) {
      message = '25% extra discount unlocked! Add 1 more item to get 30% off.';
    } else if (!giftSelected) {
      message = 'Congratulations! 30% off + a FREE GIFT are unlocked.';
    } else {
      message = 'Congratulations! 30% off + your FREE GIFT are applied.';
    }

    copies.forEach((copy) => { copy.textContent = message; });
    progressBars.forEach((progress) => { progress.style.width = `${Math.min(quantity / 4, 1) * 100}%`; });
    document.querySelectorAll('[data-tier]').forEach((tier) => {
      tier.classList.toggle('unlocked', quantity >= Number(tier.dataset.tier));
    });

    const threshold = quantity >= 4 ? 4 : quantity >= 3 ? 3 : quantity >= 2 ? 2 : 0;
    if (previousRewardThreshold !== null && threshold > previousRewardThreshold) triggerRewardCelebration(threshold);
    previousRewardThreshold = threshold;
  }

  function triggerRewardCelebration(threshold) {
    document.querySelectorAll(`[data-tier="${threshold}"]`).forEach((tier) => {
      tier.classList.remove('reward-unlocked-now');
      requestAnimationFrame(() => tier.classList.add('reward-unlocked-now'));
      window.setTimeout(() => tier.classList.remove('reward-unlocked-now'), 900);
    });
    const rewards = document.querySelector('#cart-drawer [data-cart-rewards]');
    if (!rewards) return;
    const burst = document.createElement('span');
    burst.className = 'reward-celebration';
    burst.setAttribute('aria-hidden', 'true');
    for (let index = 0; index < 10; index += 1) {
      const spark = document.createElement('i');
      spark.style.setProperty('--spark-x', `${-72 + index * 16}px`);
      spark.style.setProperty('--spark-delay', `${(index % 3) * 35}ms`);
      burst.appendChild(spark);
    }
    rewards.appendChild(burst);
    window.setTimeout(() => burst.remove(), 950);
  }

  function syncUpsellToggles(cart) {
    const quantities = new Map();
    cart.items.forEach((item) => quantities.set(String(item.variant_id), (quantities.get(String(item.variant_id)) || 0) + item.quantity));
    document.querySelectorAll('[data-upsell-toggle]').forEach((toggle) => {
      const selected = (quantities.get(String(toggle.dataset.variantId)) || 0) > 0;
      toggle.setAttribute('aria-checked', String(selected));
      toggle.classList.toggle('selected', selected);
    });
    const cartProductIds = new Set(cart.items.map((item) => String(item.product_id)));
    document.querySelectorAll('.compact-upsells-cart').forEach((section) => {
      let visible = 0;
      section.querySelectorAll('[data-upsell-item]').forEach((item) => {
        const show = !cartProductIds.has(String(item.dataset.productId)) && visible < 3;
        item.hidden = !show;
        if (show) visible += 1;
      });
    });
  }

  function giftCallToAction(state) {
    if (!state.giftMissing) return '';
    return `<button class="cart-gift-cta" type="button" data-open-gift-picker>
      <span class="gift-box-icon" aria-hidden="true"></span>
      <span><b>Your free gift is ready!</b><small>Choose one complimentary piece</small></span>
      <strong>Select</strong>
    </button>`;
  }

  async function productData(handle) {
    if (!productDataCache.has(handle)) {
      productDataCache.set(handle, fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } }).then((response) => {
        if (!response.ok) throw new Error('Unable to load product pricing.');
        return response.json();
      }));
    }
    return productDataCache.get(handle);
  }

  async function hydrateCartSavings(cart) {
    let compareTotal = 0;
    await Promise.all(cart.items.map(async (item) => {
      const product = await productData(item.handle);
      const variant = product.variants.find((candidate) => Number(candidate.id) === Number(item.variant_id));
      const comparePrice = Number(variant?.compare_at_price || item.original_price || 0);
      compareTotal += Math.max(comparePrice, item.original_price) * item.quantity;
      const priceNode = [...document.querySelectorAll('[data-line-key]')].find((line) => line.dataset.lineKey === item.key)?.querySelector('.cart-line-price');
      if (priceNode && comparePrice > item.final_price) {
        priceNode.innerHTML = `<s>${formatMoney(comparePrice * item.quantity)}</s><strong>${formatMoney(item.final_line_price)}</strong>`;
      }
    }));
    const savings = document.querySelector('[data-cart-savings]');
    if (savings) savings.textContent = `-${formatMoney(Math.max(0, compareTotal - cart.total_price))}`;
  }

  function renderCart(cart) {
    const state = rewardState(cart);
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = state.paidQuantity;
      badge.hidden = state.paidQuantity === 0;
    });

    const heading = document.querySelector('[data-cart-heading-count]');
    if (heading) heading.textContent = `${state.paidQuantity} ${state.paidQuantity === 1 ? 'item' : 'items'}`;

    const lines = document.querySelector('[data-cart-lines]');
    if (lines) {
      lines.innerHTML = cart.items.length
        ? `${giftCallToAction(state)}${cart.items.map(cartLine).join('')}`
        : `<div class="empty-cart"><p>${escapeHtml(routes.strings?.emptyCart || 'Your cart is currently empty.')}</p><a class="primary-button" href="/collections/all-jewelry">${escapeHtml(routes.strings?.shopCollection || 'Shop the collection')}</a></div>`;
    }

    const footer = document.querySelector('[data-cart-footer]');
    if (footer) footer.hidden = state.paidQuantity === 0;
    const total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    hydrateCartSavings(cart).catch((error) => console.error(error));
    document.querySelectorAll('.compact-upsells-cart').forEach((section) => { section.hidden = state.paidQuantity === 0; });
    updateRewards(state.paidQuantity, state.giftItems.length > 0);
    syncUpsellToggles(cart);
    return state;
  }

  async function getCart() {
    const response = await fetch(`${routes.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load the cart.');
    return response.json();
  }

  async function trimGiftItems(cart) {
    const state = rewardState(cart);
    if (!state.giftItems.length) return cart;
    const updates = {};
    let keptGift = false;
    state.giftItems.forEach((item) => {
      if (state.giftUnlocked && !keptGift) {
        updates[item.key] = 1;
        keptGift = true;
      } else {
        updates[item.key] = 0;
      }
    });
    const needsUpdate = Object.entries(updates).some(([key, quantity]) => cart.items.find((item) => item.key === key)?.quantity !== quantity);
    if (!needsUpdate) return cart;

    const response = await fetch(`${routes.cartUpdate || '/cart/update'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!response.ok) throw new Error('Unable to update the free gift.');
    return response.json();
  }

  function closeGiftPicker() {
    const picker = document.querySelector('[data-gift-picker]');
    if (picker) picker.hidden = true;
    if (![...document.querySelectorAll('[data-drawer]')].some((element) => !element.hidden)) document.body.style.overflow = '';
  }

  function openGiftPicker(cart) {
    const picker = document.querySelector('[data-gift-picker]');
    if (!picker || !rewardState(cart).giftMissing) return;
    picker.querySelectorAll('[data-gift-option]').forEach((option) => {
      option.disabled = false;
      option.classList.remove('selected');
      const label = option.querySelector('[data-gift-option-label]');
      if (label) label.textContent = 'Select';
    });
    picker.hidden = false;
    document.body.style.overflow = 'hidden';
    picker.querySelector('[data-close-gift-picker]')?.focus();
  }

  async function addGift(variantId) {
    const response = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _cj_free_gift: 'true' } }] })
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.description || 'Unable to add this free gift.');
    }
    const cart = await trimGiftItems(await getCart());
    renderCart(cart);
    closeGiftPicker();
    openDrawer('cart-drawer');
    return cart;
  }

  async function refreshCart({ open = false } = {}) {
    try {
      const cart = await trimGiftItems(await getCart());
      const state = renderCart(cart);
      if (open) openDrawer('cart-drawer');
      if (state.giftMissing) openGiftPicker(cart);
    } catch (error) {
      console.error(error);
    }
  }

  async function changeLine(key, quantity) {
    const response = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('Unable to update the cart.');
    const cart = await trimGiftItems(await response.json());
    const state = renderCart(cart);
    if (state.giftMissing) openGiftPicker(cart);
    return cart;
  }

  async function toggleUpsell(toggle) {
    const variantId = Number(toggle.dataset.variantId);
    if (!variantId) return;
    toggle.disabled = true;
    try {
      const cart = await trimGiftItems(await getCart());
      const selectedLine = cart.items.find((item) => Number(item.variant_id) === variantId);
      if (selectedLine) {
        await changeLine(selectedLine.key, Math.max(0, selectedLine.quantity - 1));
      } else {
        const response = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Unable to add this recommendation.');
        const updatedCart = await trimGiftItems(await getCart());
        const state = renderCart(updatedCart);
        if (state.giftMissing) openGiftPicker(updatedCart);
      }
    } finally {
      toggle.disabled = false;
    }
  }

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-open-drawer]');
    if (opener) {
      event.preventDefault();
      if (opener.dataset.openDrawer === 'cart-drawer') await refreshCart();
      openDrawer(opener.dataset.openDrawer);
      return;
    }

    if (event.target.closest('[data-close-drawer]')) {
      closeDrawers();
      return;
    }

    if (event.target.closest('[data-close-gift-picker]')) {
      closeGiftPicker();
      return;
    }

    const giftOverlay = event.target.closest('[data-gift-picker]');
    if (giftOverlay && event.target === giftOverlay) {
      closeGiftPicker();
      return;
    }

    const giftOpener = event.target.closest('[data-open-gift-picker]');
    if (giftOpener) {
      giftOpener.disabled = true;
      try { openGiftPicker(await getCart()); } catch (error) { console.error(error); }
      finally { giftOpener.disabled = false; }
      return;
    }

    const giftOption = event.target.closest('[data-gift-option]');
    if (giftOption) {
      giftOption.disabled = true;
      giftOption.classList.add('selected');
      const label = giftOption.querySelector('[data-gift-option-label]');
      if (label) label.textContent = 'Adding…';
      try { await addGift(giftOption.dataset.giftVariant); }
      catch (error) {
        console.error(error);
        giftOption.disabled = false;
        giftOption.classList.remove('selected');
        if (label) label.textContent = 'Select';
      }
      return;
    }

    const changeGift = event.target.closest('[data-change-gift]');
    if (changeGift) {
      changeGift.disabled = true;
      try {
        const cart = await changeLine(changeGift.dataset.changeGift, 0);
        openGiftPicker(cart);
      } catch (error) { console.error(error); }
      return;
    }

    const upsellToggle = event.target.closest('[data-upsell-toggle]');
    if (upsellToggle) {
      try { await toggleUpsell(upsellToggle); } catch (error) { console.error(error); }
      return;
    }

    const overlay = event.target.closest('[data-drawer]');
    if (overlay && event.target === overlay) {
      closeDrawers();
      return;
    }

    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      remove.disabled = true;
      try { await changeLine(remove.dataset.cartRemove, 0); } catch (error) { console.error(error); }
      return;
    }

    const quantity = event.target.closest('[data-cart-quantity]');
    if (quantity) {
      quantity.disabled = true;
      try { await changeLine(quantity.dataset.cartQuantity, Number(quantity.dataset.quantity)); } catch (error) { console.error(error); }
      return;
    }

    const thumbnail = event.target.closest('[data-gallery-image]');
    if (thumbnail) {
      const image = document.querySelector('[data-product-main-image], .product-gallery img');
      if (image) {
        image.removeAttribute('srcset');
        image.src = thumbnail.dataset.galleryImage;
        image.alt = thumbnail.dataset.galleryAlt || image.alt;
      }
      document.querySelectorAll('[data-gallery-image]').forEach((button) => {
        const selected = button === thumbnail;
        button.classList.toggle('selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      const counter = document.querySelector('[data-media-current]');
      if (counter) counter.textContent = thumbnail.dataset.galleryIndex || '1';
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const picker = document.querySelector('[data-gift-picker]');
      if (picker && !picker.hidden) closeGiftPicker();
      else closeDrawers();
    }
  });

  document.addEventListener('change', async (event) => {
    const select = event.target.closest('[data-upsell-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const item = select.closest('[data-upsell-item]');
    const toggle = item?.querySelector('[data-upsell-toggle]');
    if (toggle) toggle.dataset.variantId = option.value;
    const price = item?.querySelector('[data-upsell-price]');
    const compare = item?.querySelector('[data-upsell-compare]');
    const saving = item?.querySelector('[data-upsell-saving]');
    if (price) price.textContent = option.dataset.price || '';
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (saving) {
      saving.textContent = option.dataset.saving || '';
      saving.hidden = !option.dataset.saving;
    }
    try { syncUpsellToggles(await getCart()); } catch (error) { console.error(error); }
  });

  document.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
    document.querySelector('[data-product-form]')?.requestSubmit(document.querySelector('[data-product-form] [data-add-to-cart]'));
  });

  document.querySelector('.brand-button')?.addEventListener('click', (event) => {
    event.preventDefault();
    window.location.assign(event.currentTarget.href || '/');
  });

  document.querySelector('[data-nav-toggle]')?.addEventListener('click', (event) => {
    const button = event.currentTarget;
    const submenu = document.querySelector('[data-nav-submenu]');
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    if (submenu) submenu.hidden = expanded;
    const chevron = button.querySelector('span');
    chevron?.classList.toggle('chevron-up', !expanded);
    chevron?.classList.toggle('chevron-down', expanded);
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      if (submitter?.name === 'checkout') return;
      event.preventDefault();
      const button = form.querySelector('[data-add-to-cart]');
      const message = form.querySelector('[data-product-message]');
      if (button) {
        button.disabled = true;
        const label = button.querySelector('[data-add-label]');
        if (label) label.textContent = 'Adding…';
      }
      if (message) message.textContent = '';

      try {
        const response = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.description || 'Unable to add this item.');
        }
        await refreshCart({ open: true });
      } catch (error) {
        if (message) message.textContent = error.message;
      } finally {
        if (button) {
          const selected = form.querySelector('[data-variant-select]')?.selectedOptions[0];
          const available = selected ? selected.dataset.available === 'true' : true;
          button.disabled = !available;
          const label = button.querySelector('[data-add-label]');
          if (label) label.textContent = available ? (routes.strings?.addToCart || 'Add to cart') : (routes.strings?.soldOut || 'Sold out');
        }
      }
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('[data-product-form]');
    const variants = [...select.options].map((option) => ({
      option,
      values: JSON.parse(option.dataset.options || '[]'),
      available: option.dataset.available === 'true'
    }));

    const syncVariant = () => {
      const option = select.selectedOptions[0];
      const button = form?.querySelector('[data-add-to-cart]');
      const buyNow = form?.querySelector('.product-buy-now');
      const price = document.querySelector('[data-product-price]');
      const compare = document.querySelector('[data-product-compare]');
      const stickyPrice = document.querySelector('[data-sticky-price]');
      const stickyCompare = document.querySelector('[data-sticky-compare]');
      const image = document.querySelector('[data-product-main-image], .product-gallery img');
      const isAvailable = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
      if (stickyCompare) {
        stickyCompare.textContent = option.dataset.compare || '';
        stickyCompare.hidden = !option.dataset.compare;
      }
      if (button) {
        button.disabled = !isAvailable;
        const label = button.querySelector('[data-add-label]');
        const buttonPrice = button.querySelector('[data-add-price]');
        if (label) label.textContent = isAvailable ? (routes.strings?.addToCart || 'Add to cart') : (routes.strings?.soldOut || 'Sold out');
        if (buttonPrice) buttonPrice.textContent = isAvailable ? ` · ${option.dataset.price || ''}` : '';
      }
      if (buyNow) buyNow.disabled = !isAvailable;
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
        image.alt = option.dataset.imageAlt || image.alt;
      }
      let chosenValues = [];
      try { chosenValues = JSON.parse(option.dataset.options || '[]'); } catch (_) {}
      form?.querySelectorAll('[data-option-group]').forEach((group) => {
        const index = Number(group.dataset.optionGroup);
        const selectedValue = chosenValues[index];
        const label = group.querySelector('[data-selected-option-label]');
        if (label) label.textContent = selectedValue || '';
        group.querySelectorAll('[data-option-value]').forEach((choice) => {
          const selected = choice.dataset.optionValue === selectedValue;
          choice.classList.toggle('selected', selected);
          choice.setAttribute('aria-pressed', String(selected));
          const possible = variants.some((variant) => variant.available && variant.values[index] === choice.dataset.optionValue);
          choice.classList.toggle('unavailable', !possible);
        });
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    };

    select.addEventListener('change', syncVariant);
    form?.querySelectorAll('[data-option-value]').forEach((choice) => {
      choice.addEventListener('click', () => {
        const group = choice.closest('[data-option-group]');
        const changedIndex = Number(group.dataset.optionGroup);
        const desired = [...form.querySelectorAll('[data-option-group]')].map((item) => item.querySelector('[data-option-value].selected')?.dataset.optionValue || '');
        desired[changedIndex] = choice.dataset.optionValue;
        let match = variants.find((variant) => variant.values.every((value, index) => value === desired[index]));
        if (!match) match = variants.find((variant) => variant.available && variant.values[changedIndex] === desired[changedIndex]);
        if (!match) return;
        select.value = match.option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    syncVariant();
  });

  document.querySelectorAll('[data-product-quantity]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.product-quantity')?.querySelector('input');
      if (!input) return;
      const next = Number(input.value || 1) + (button.dataset.productQuantity === 'plus' ? 1 : -1);
      input.value = Math.max(1, next);
    });
  });

  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('[data-country-flag]').forEach((flag) => {
    const code = flag.dataset.countryFlag || '';
    flag.textContent = [...code.toUpperCase()].map((character) => String.fromCodePoint(127397 + character.charCodeAt(0))).join('');
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-client-filter-form]').forEach((form) => {
    const cards = [...document.querySelectorAll('[data-filter-product-grid] [data-product-card]')];
    const resultCount = form.querySelector('[data-filter-result-count]');
    const noProducts = document.querySelector('[data-client-no-products]');

    function selectedValues(group) {
      return [...form.querySelectorAll(`[data-client-filter="${group}"]:checked`)].map((input) => input.value);
    }

    function matchesPrice(price, ranges) {
      if (!ranges.length) return true;
      return ranges.some((range) => {
        if (range === 'under-50') return price < 50;
        if (range === '50-55') return price >= 50 && price <= 55;
        return price > 55;
      });
    }

    function previewFilters() {
      const types = selectedValues('type');
      const finishes = selectedValues('finish');
      const prices = selectedValues('price');
      let matches = 0;

      cards.forEach((card) => {
        const visible = (!types.length || types.includes(card.dataset.filterType))
          && (!finishes.length || finishes.includes(card.dataset.filterFinish))
          && matchesPrice(Number(card.dataset.filterPrice || 0), prices);
        card.dataset.filterMatch = String(visible);
        if (visible) matches += 1;
      });
      if (resultCount) resultCount.textContent = matches;
      return matches;
    }

    form.addEventListener('change', previewFilters);
    form.addEventListener('submit', (event) => event.preventDefault());
    form.querySelector('[data-apply-client-filters]')?.addEventListener('click', () => {
      const matches = previewFilters();
      cards.forEach((card) => { card.hidden = card.dataset.filterMatch === 'false'; });
      if (noProducts) noProducts.hidden = matches !== 0;
      closeDrawers();
    });
    form.querySelector('[data-clear-client-filters]')?.addEventListener('click', () => {
      form.querySelectorAll('[data-client-filter]').forEach((input) => { input.checked = false; });
      cards.forEach((card) => { card.hidden = false; card.dataset.filterMatch = 'true'; });
      if (resultCount) resultCount.textContent = cards.length;
      if (noProducts) noProducts.hidden = true;
    });

    previewFilters();
  });

  const referenceHeader = document.querySelector('.reference-header');
  if (referenceHeader) {
    const syncReferenceHeader = () => {
      const isScrolled = window.scrollY > 56;
      const isAtBottom = isScrolled && window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      referenceHeader.classList.toggle('is-scrolled', isScrolled);
      referenceHeader.classList.toggle('is-at-bottom', isAtBottom);
    };
    syncReferenceHeader();
    window.addEventListener('scroll', syncReferenceHeader, { passive: true });
  }

  document.querySelectorAll('[data-featured-carousel]').forEach((carousel) => {
    const section = carousel.closest('.featured-products');
    const scrollCarousel = (direction) => carousel.scrollBy({ left: carousel.clientWidth * direction, behavior: 'smooth' });
    section?.querySelector('[data-featured-carousel-previous]')?.addEventListener('click', () => scrollCarousel(-1));
    section?.querySelector('[data-featured-carousel-next]')?.addEventListener('click', () => scrollCarousel(1));
  });

  document.querySelectorAll('[data-review-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-review-slide]')];
    let current = 0;

    const render = () => {
      slides.forEach((slide, index) => {
        const active = index === current;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
    };

    carousel.querySelector('[data-review-prev]')?.addEventListener('click', () => {
      current = (current - 1 + slides.length) % slides.length;
      render();
    });
    carousel.querySelector('[data-review-next]')?.addEventListener('click', () => {
      current = (current + 1) % slides.length;
      render();
    });
    render();
  });

  document.querySelectorAll('.footer-grid').forEach((grid) => {
    const footer = grid.closest('.site-footer');
    const groups = [...grid.querySelectorAll('[data-footer-group]')];
    const syncFooter = () => {
      const hasOpenGroup = groups.some((group) => group.open);
      grid.classList.toggle('has-open', hasOpenGroup);
      footer?.classList.toggle('is-expanded', hasOpenGroup);
    };

    groups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (group.open) {
          groups.forEach((otherGroup) => {
            if (otherGroup !== group) otherGroup.open = false;
          });
        }
        syncFooter();
      });
    });
    syncFooter();
  });

  refreshCart();

})();
